module.exports = __webpack_public_path__ + "img/MOCo-icon.ed134924.png";